import type { AnalysisResultData } from "../../../services/AnalysisResultService";

/** Serialises the result for saving: saved sections plus sections that only exist in the order-derived view, and the derived summary rows. */
export function buildResultPayload(rawResultData: AnalysisResultData, resultData: AnalysisResultData): string {
  const savedKeys = new Set(rawResultData.sections.map(section => section.analysisKey));
  return JSON.stringify({
    ...rawResultData,
    sections: [...rawResultData.sections, ...resultData.sections.filter(section => !savedKeys.has(section.analysisKey))],
    summaryRows: resultData.summaryRows,
  });
}
